<template>
    <Card :title="$t('labels.compare_integrations')">
        <template v-if="integrationsAreNotSelected">
            <div class="card-body">
                <div class="row">
                    <div class="col-md-6">
                        <FormGroup :label="`${$t('labels.integration')} 1`">
                            <AppAutoComplete
                                :url="`/projects/${$route.params.projectUuid}/pim/channels`"
                                :model-value="integrationSource?.uuid"
                                :selected-value="integrationSource?.name"
                                @update:model-value="integrationSource = $event"
                                :queryParams="queryParamsSource"
                                canBeEmpty
                            />
                        </FormGroup>
                    </div>
                    <div class="col-md-6">
                        <FormGroup :label="`${$t('labels.integration')} 2`">
                            <AppAutoComplete
                                :url="`/projects/${$route.params.projectUuid}/pim/channels`"
                                :model-value="integrationTarget?.uuid"
                                :selected-value="integrationTarget?.name"
                                @update:model-value="integrationTarget = $event"
                                :queryParams="queryParamsTarget"
                                canBeEmpty
                            />
                        </FormGroup>
                    </div>
                </div>
            </div>
            <div class="card-footer d-flex justify-content-end">
                <AppButton color="indigo" @click="startCompare" :disabled="!integrationSource || !integrationTarget">
                    {{ $t('buttons.compareIntegrations') }}
                </AppButton>
            </div>
        </template>
        <template v-else>
            <CompareIntegrationsTable
                :integration-source="integrationSource"
                :integration-target="integrationTarget"
                ref="compareTable"
            />
        </template>
    </Card>
</template>

<script>
import Card from '../../../../components/new/CardComponent.vue';
import FormGroup from '../../../../components/new/form/group/FormGroup.vue';
import AppAutoComplete from '../../../../components/new/form/autocomplete/AppAutoComplete.vue';
import AppButton from '../../../../components/new/button/AppButton.vue';
import CompareIntegrationsTable from './CompareIntegrationsTable.vue';

export default {
    name: "CompareIntegrationsPage",
    components: {
        Card, FormGroup, AppAutoComplete, AppButton,
        CompareIntegrationsTable
    },
    data() {
        return {
            integrationSource: null,
            integrationTarget: null,
            integrationsAreNotSelected: true
        };
    },
    methods: {
        startCompare() {
            this.integrationsAreNotSelected = false;
            this.$nextTick(() => {
                this.$refs.compareTable.fetchIntegrationProducts();
            });
        }
    },
    computed: {
        queryParamsSource() {
            let params = {};
            if (this.integrationTarget) {
                params.ignore_uuids = [this.integrationTarget.uuid];
            }
            return params;
        },
        queryParamsTarget() {
            let params = {exclude_suppliers: 1};
            if (this.integrationSource) {
                params.ignore_uuids = [this.integrationSource.uuid];
            }
            return params;
        }
    }
}
</script>
